<template>
  <div>
    <div class="modal fade" id="addDelegacjaModal" ref="modalEle" tabindex="-1">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Cele delegacji</h5>
            <button type="button" class="close ms-auto" data-bs-dismiss="modal">
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h6 class="mb-0">Lista celów delegacji</h6>
              <button class="btn btn-sm btn-success" @click="addCel"><i class="bi bi-plus-lg me-1"></i> Dodaj
                cel</button>
            </div>
            <div class="custom-table">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Cel delegacji</th>
                    <th>Użyty</th>
                    <th>Akcje</th>
                  </tr>
                </thead>
                <tbody>
				  <tr v-if="addingNew">
                    <td>Nowy</td>
                    <td><input v-model="newCel.name" class="form-control" /></td>
                    <td></td>
                    <td>
                      <button @click="saveNewCel" class="btn btn-sm btn-success me-1"><i
                          class="bi bi-save me-2"></i>Zapisz
                      </button>
                      <button @click="cancelNewCel" class="btn btn-sm btn-danger"><i
                          class="bi bi-x-circle me-2"></i>Anuluj
                      </button>
                    </td>
                  </tr>
                  <tr v-for="(cel, index) in cele" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>
                      <input v-if="editingId === cel.id" v-model="cel.name" class="form-control" />
                      <span v-else>{{ cel.name }}</span>
                    </td>
                    <td>{{ cel.delegacje_count }}</td>
                    <td>
                      <button v-if="editingId === cel.id" @click="updateCel(cel)" class="btn btn-sm btn-success me-2">
                        Zapisz
                      </button>
                      <button v-else @click="editCel(cel.id)" class="btn btn-sm btn-outline-info me-2"><i
                          class="bi bi-pencil me-2"></i>Edytuj
                      </button>
                      <button v-if="cel.delegacje_count === 0" @click="deleteCel(cel.id)" class="btn btn-sm btn-danger">
                        <i class="bi bi-trash me-2"></i>Usuń
                      </button>
                    </td>
                  </tr>

                </tbody>
              </table>
            </div>
          </div>


          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Zamknij</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { Modal } from 'bootstrap';

export default {
  props: {
    cele: { type: Array, default: () => [] },
  },

  data() {
    return {
      modalObj: null,
      editingId: null,
      addingNew: false,
      newCel: this.getEmptyForm()
    };
  },

  mounted() {
    this.modalObj = new Modal(this.$refs.modalEle);
  },

  methods: {
    resetForm() {
      this.editingId = null;
      this.addingNew = false;
      this.newCel = this.getEmptyForm();
    },
    getEmptyForm() {
      return {
        id: null,
        name: ''
      };
    },

    addCel() {
      this.addingNew = true;
      this.newCel = this.getEmptyForm();
    },

    cancelNewCel() {
      this.addingNew = false;
      this.newCel = this.getEmptyForm();
    },

    editCel(id) {
      this.editingId = id;
    },

    updateCel(cel) {
      this.$emit("update-cel", { ...cel });
      this.resetForm();
      this.hide();
    },

    saveNewCel() {
      if (!this.newCel) {
        this.errorMsg("Cel musi posiadać nazwę.");
        return;
      }
      this.$emit("save-cel", this.newCel);
      this.resetForm();
      this.hide();
    },

    deleteCel(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie celu delegacji',
        html: 'Czy na pewno chcesz usunąć wybrany cel delegacji?',
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
        timer: false,
        position: 'center'
      }).then((result) => {
        if (result.isConfirmed) {

          this.$emit("delete-cel", id);
          this.resetForm();
          this.hide();

        }

      });
    },

    show() {
      this.modalObj.show();
    },
    errorMsg(resp) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: 'warning',
        title: 'Błąd!',
        html: resp,
        showClass: { popup: 'animate__animated animate__fadeInDown' },
        hideClass: { popup: 'animate__animated animate__fadeOutUp' },
        timer: 2500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    },


    hide() {
      this.resetForm();

      if (this.modalObj) {
        this.modalObj.hide();
      }
    }
  }
};
</script>

<style>
.position-absolute {
  background: white;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #ddd;
}
</style>